import * as React from 'react';
import './Tile.scss';
import { DocumentStatus } from '@account-verification-frontend/types';
import { CLASSNAME_PREFIX as cp } from '../../componentConfig';
import TileButton from './../TileButton/TileButton';
function Tile(_a) {
    var translate = _a.t, handler = _a.handler, _b = _a.opts, status = _b.status, verificationType = _b.verificationType, index = _b.index, documents = _b.documents, prefix = _b.prefix, scenarioType = _b.scenarioType;
    var documentNames = documents.map(function (docName) { return docName.split(' ').join('_'); });
    var isStatusPending = function () { return status === DocumentStatus.PENDING; };
    var isStatusRequired = function () { return status === DocumentStatus.REQUIRED; };
    var isStatusSubmitted = function () { return status === DocumentStatus.SUBMITTED; };
    var isStatusNotUploaded = function () { return status === DocumentStatus.NOT_UPLOADED; };
    var setStatus = function () { return (status === DocumentStatus.REQUIRED ? '' : status); };
    var isClickable = function () { return isStatusPending() || isStatusRequired() || isStatusNotUploaded(); };
    return (React.createElement("div", { className: cp + "-tile" },
        React.createElement("div", { className: cp + "-tile__header" },
            React.createElement("span", { className: cp + "-tile__icon " + cp + "-tile__icon--" + prefix + " " + (isStatusPending() || isStatusSubmitted() ? cp + '-tile__icon--pending' : '') }),
            React.createElement("div", null,
                React.createElement("span", null,
                    translate('SCENARIO_NUMBER_TITLE'),
                    " ",
                    index),
                React.createElement("h2", null, translate(prefix + "_TITLE")))),
        React.createElement("div", { className: cp + "-tile__content" },
            translate('DOCUMENT_UPLOAD_MESSAGE'),
            React.createElement("ul", null, Object.keys(documentNames).map(function (docName, i) {
                return React.createElement("li", { key: docName }, translate(documentNames[i]));
            }))),
        React.createElement(TileButton, { t: translate, clickHandler: function () { return handler(verificationType, scenarioType); }, isClickable: isClickable(), status: setStatus() })));
}
export default Tile;
//# sourceMappingURL=Tile.js.map